import { Vue, Component, Prop} from "vue-property-decorator";
import CollectionControl from "@/components/collection-control";
import XTable from "@/components/x-table";
import XTh from "@/components/x-table/x-th";
import {lexLabel} from "@/lib/helpers";
import ActionTh from "@/components/x-table/action-th";
import ActionTd from "@/components/x-table/action-td";

import PanelCusMiseSecurite from './panel-mise-securite';
import CavCusMiseSecurite from '@/lib/models/cav-cus-mise-securite';

@Component
export default class ControlCusMiseSecurite extends Vue {

  @Prop({type: Array}) readonly collection!: CavCusMiseSecurite[];

  render() {
    return <CollectionControl
      data={this.collection}
      clazz={PanelCusMiseSecurite}
      scopedSlots={{
        body: ({ data, onEdit, onDelete }) => (
          <XTable data={data}
            class="is-full-width is-bordered is-small"
            scopedSlots={{
              header: () => (
                <tr>
                  <XTh prop="miseSecurite" lblFn={lexLabel}>Mise en sécurité</XTh>
                  <XTh prop="annee">Année</XTh>
                  <ActionTh/>
                </tr>
              ),
              row: ({d}: {d: CavCusMiseSecurite}) => (
                <tr>
                  <td>{lexLabel(d.miseSecurite)}</td>
                  <td>{d.annee}</td>
                  <ActionTd
                    onEdit={() => onEdit(d)}
                    onDelete={() => onDelete(d)}
                  />
                </tr>
              )
            }}>
          </XTable>
        )
      }}>
    </CollectionControl>;
  }

}

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-756c6c2b/control-mise-securite.tsx" });